import React from 'react';

import TooltipWrapper from '../Form/TooltipWrapper';
import { ConvertToRelativeTime } from '../../resources/helper';

import './_styles.scss';

export const ChargerLastUpdate = ({ updateReason, timeToShow }) => {
  if (!timeToShow) return null;

  const tooltip = updateReason ? `${timeToShow} — ${updateReason}` : timeToShow;

  return (
    <div className="charger-last-update">
      <span className="toolbar-separator" />

      <TooltipWrapper hideHighlight tip={tooltip}>
        <div className="charger-last-update-label">Last Update: </div>
        <div className="withTooltip">
          <ConvertToRelativeTime date={timeToShow} />
        </div>
      </TooltipWrapper>
    </div>
  );
};
